import React, { FC, Children, Fragment, CSSProperties } from 'react'
import cx from 'classnames'
import styles from './Stack.module.scss'

type StackProps = {
  className?: string
  component?: keyof JSX.IntrinsicElements
  space?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxl'
  style?: CSSProperties
}

export const Stack: FC<StackProps> = ({
  children,
  className,
  component: StackComponent = 'div',
  space = 'large',
  ...props
}) => {
  const stackItems = Children.toArray(children)
  const isList = StackComponent === 'ol' || StackComponent === 'ul'
  const StackItemComponent = isList ? 'li' : 'div'

  if (stackItems.length <= 1 && !isList) {
    return <Fragment>{stackItems}</Fragment>
  }

  return (
    <StackComponent className={cx(styles.stack, className)} {...props}>
      {stackItems.map((child, index) => (
        <StackItemComponent className={cx(styles.stackItem, styles[space])} key={index}>
          {child}
        </StackItemComponent>
      ))}
    </StackComponent>
  )
}

Stack.displayName = 'Stack'
